import { render } from "./grade15.vue?vue&type=template&id=23004d80"
import script from "./grade15.vue?vue&type=script&lang=js"
export * from "./grade15.vue?vue&type=script&lang=js"

import "./grade15.vue?vue&type=style&index=0&id=23004d80&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__